import React from "react";

import { colors } from "@zapalacorp/tokens";
import Button, { Color } from "Components/Form/Button";
import { Printer } from "iconsax-react";
import { useTranslation } from "react-i18next";

interface ISubmitButton {
  disabled: boolean;
  handleSubmit: () => void;
  isLoading?: boolean;
}

export const SubmitButton = ({ disabled, handleSubmit, isLoading }: ISubmitButton) => {
  const { t: translate } = useTranslation();

  return (
    <Button
      startIcon={<Printer size="16" color={colors.white} />}
      customColor={Color.SUCCESS}
      onClick={handleSubmit}
      disabled={disabled}
      loading={isLoading}
    >
      {translate("print")}
    </Button>
  );
};
